import { render } from "./OnLaysBenefits.vue?vue&type=template&id=45cfb8b6"
import script from "./OnLaysBenefits.vue?vue&type=script&lang=js"
export * from "./OnLaysBenefits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__